import { useLazyQuery } from '@apollo/client';
import {
  CircularLoadingIndicator,
  LoadingOrError,
  PageError,
  useAuthContext,
} from '@custom/dx3';
import React, { type PropsWithChildren, useEffect, useMemo } from 'react';
import { GET_BASIC_USER_DATA } from '../store/queries/utilityQueries';
import styles from './PrivateRoute.module.scss';

// got from here https://dev.to/iamandrewluca/private-route-in-react-router-v6-lg5
// && https://stackblitz.com/github/remix-run/react-router/tree/main/examples/auth?file=src/App.tsx

export function PrivateRoute({ children }: PropsWithChildren): JSX.Element {
  const { loginStatus } = useAuthContext();

  const [getUserData, { loading, error }] = useLazyQuery(GET_BASIC_USER_DATA);

  useEffect(() => {
    if (loginStatus === 'LOGGED_IN') {
      getUserData();
    }
  }, [getUserData, loginStatus]);

  const notSignedIn = useMemo(
    () => (
      <div className={styles['not-signed-in']}>
        <h2>You are not logged in.</h2>
        <h5>Please sign in to X2</h5>
      </div>
    ),
    []
  );

  const loadingIndicator = useMemo(
    () => (
      <div className={styles['loading-wrapper']}>
        <CircularLoadingIndicator />
      </div>
    ),
    []
  );

  if (loginStatus === 'LOGGED_OUT') return notSignedIn;

  return (
    <LoadingOrError
      loading={loading || loginStatus === 'LOADING'}
      error={error}
      errorIndicator={<PageError className={styles['error-indicator']} />}
      loadingIndicator={loadingIndicator}
    >
      {children}
    </LoadingOrError>
  );
}
